export default "ec0b9ba40fcab24b.png"